import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields/';

const create = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/lw_talkrooms`),
    data,
  });
};

const list = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/lw_talkrooms/list`),
    params,
  });
};

const detail = (fieldId, lwTalkroomId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/lw_talkrooms/${lwTalkroomId}`),
    params,
  });
};

export const LwTalkroomApi = {
  create,
  list,
  detail,
};

export default LwTalkroomApi;



// WEBPACK FOOTER //
// ./src/services/LwTalkroomApi.js